module.exports = __webpack_public_path__ + "fonts/Montserrat-ExtraBold.bf087000.ttf";